import * as Yup from 'yup';

import { Strings } from '@app/constants';

export const addTaskBoardSchema = Yup.object()
  .shape({
    project: Yup.mixed()
      .notOneOf([''], Strings.validation.selectRequired(Strings.field.projectName))
      .required(Strings.validation.selectRequired(Strings.field.projectName)),
  })
  .required();

export const defaultSchema = Yup.object().shape({});
